import { defineStore } from "pinia"

export default defineStore("dashboardStore", {
  state: () => ({
    limit: 4,
  }),
})
